import { set, unset, contains, isOver } from "../../js/lib/util";
const breakpoint = 999;
const LOGO_SCROLL_OFFSET = 8;
const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
// 'close' function - remove is-active and set height to 0.
const close = (links, groups) => {
  //
  unset(groups.concat(links), "is-active");
  unset(document.body, "menu-open");
  for (let group of groups) {
    group.style.height = "0px";
  }
};

class Header {
  constructor(el) {
    this.el = el;
    this.links = Array.from(el.querySelectorAll(".js-link"));
    this.groups = Array.from(el.querySelectorAll(".js-subnav"));
    this.nav = el.querySelector(".js-nav") as HTMLElement;
    this.queuedAction = false;
    this.logoLink = el.querySelector(".js-logo-link") as HTMLElement;
    this.sideLinks = Array.from(el.querySelectorAll(".js-side-link"));
    this.subNavLinks = Array.from(el.querySelectorAll(".js-subnav-link"));

    this.hideNavigation = this.hideNavigation.bind(this);
    this.toggleSubNavByClick = this.toggleSubNavByClick.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
    this.hideActiveMenu = this.hideActiveMenu.bind(this);
    this.openSubNavOnEnter = this.openSubNavOnEnter.bind(this);
    this.openSubNav = this.openSubNav.bind(this);
    this.closeSubNavOnLeave = this.closeSubNavOnLeave.bind(this);
    this.closeSubNav = this.closeSubNav.bind(this);
    this.cancelClose = this.cancelClose.bind(this);
    this.scrollHandler = this.scrollHandler.bind(this);
    this.openParentSubNavOnFocus = this.openParentSubNavOnFocus.bind(this);
    this.marketButton = el.querySelector(".market-button") as HTMLElement;
    this.state = {
      open: false,
      subNavOpen: false,
      logoCompressed: false,
    };

    this.attachEventHandlers();
    this.resizeHandler();
    this.fixHeaderPosition();

    window.openNav = (pos = 0) => {
      const link = this.links[pos];

      const group = link.parentNode?.querySelector(".js-subnav") as HTMLElement;

      if (!group) return;
      this.openSubNav(group, link);
    };

    setInterval(() => {
      this.fixHeaderPosition();
    }, 400);
  }

  attachEventHandlers() {
    for (let link of this.links) {
      link.addEventListener("click", this.toggleSubNavByClick);
      link.addEventListener("mouseenter", this.openSubNavOnEnter);
      link.parentNode?.addEventListener("mouseleave", this.closeSubNavOnLeave);
      link.addEventListener("focus", this.openSubNavOnEnter);
    }
    if (this.marketButton) {
      this.marketButton.addEventListener("click", this.openMarketModal);
    }
    /* close any subnav that is already open when focusing logo link or side links */
    this.logoLink.addEventListener("focus", this.closeSubNav);
    for (let link of this.sideLinks) {
      link.addEventListener("focus", this.closeSubNav);
    }

    for (let link of this.subNavLinks) {
      link.addEventListener("focus", this.openParentSubNavOnFocus);
    }

    for (let group of this.groups) {
      group.addEventListener("mouseleave", this.closeSubNavOnLeave);
    }
    window.addEventListener("resize", this.resizeHandler);
    window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("click", this.hideActiveMenu);
  }

  scrollHandler() {
    const scrollTop = window.scrollY;

    this.fixHeaderPosition();

    if (scrollTop > LOGO_SCROLL_OFFSET) {
      if (this.state.logoCompressed) return;
      this.state.logoCompressed = true;
      this.handleScrolled();
    } else {
      if (!this.state.logoCompressed) return;
      this.state.logoCompressed = false;
      this.handleScrolled();
    }
  }

  fixHeaderPosition() {
    var campaign = document.querySelector(".CampaignType--floating");

    if (campaign) {
      this.el.style.top = campaign.clientHeight + "px";
    } else {
      this.el.style.top = 0;
    }
  }

  handleScrolled() {
    if (this.state.logoCompressed) {
      set(this.el, "header--scrolled");
    } else {
      unset(this.el, "header--scrolled");
    }
  }

  openMarketModal(e) {
    e.preventDefault();

    set(document.body, "showing-modal");
    let modal = document.querySelector(
      `.js-modal[data-modal=region-selector]`
    ) as HTMLElement;

    if (modal) {
      // make sure the modal's parent is the body
      if (modal.parentElement !== document.body) {
        // remove it from the current parent
        if (modal.parentElement) {
          modal.parentElement.removeChild(modal);
        }

        document.body.appendChild(modal);
      }

      // if we click any of the links in the modal then we set the has-asked-market cookie
      modal.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", (e) => {
          e.preventDefault();
          document.cookie =
            "has-asked-market=true; path=/; max-age=31536000; samesite=strict";

          // redirect to the link
          window.location.href = a.href;
        });
      });

      setTimeout(() => {
        set(modal, "active");
      }, 100);
    }
  }

  toggleSubNavByClick(e) {
    e.stopPropagation();
    const link = e.currentTarget;
    const isActive = contains(link, "is-active");
    const group = link.parentNode?.querySelector(".js-subnav") as HTMLElement;
    const openMenuHeight = group ? group.children[0].offsetHeight : 0;
    const viewportHeight =
      document.documentElement.clientHeight - this.el.clientHeight;

    if (isOver(breakpoint) || !group) {
      // BraveBlog link direct to blog page only if not mobile/tablet
      if (link.title.trim() === "BraveBlog" && !isMobile) {
        return;
      } else {
        e.preventDefault();
      }
      return;
    }
    e.preventDefault();
    this.closeSubNav();

    if (!isActive) {
      group.style.height = `${Math.min(openMenuHeight, viewportHeight)}px`;
      set([group, link], "is-active");
      set([document.body], "menu-open");
    }
  }

  openSubNavOnEnter(e) {
    if (!isOver(breakpoint)) {
      return;
    }

    /* Close any subnav that is already open */
    this.closeSubNav();

    const link = e.currentTarget;
    const isActive = contains(link, "is-active");
    const group = link.parentNode?.querySelector(".js-subnav") as HTMLElement;

    if (!group) return;

    if (!isActive) {
      this.openSubNav(group, link);
    }
  }

  openParentSubNavOnFocus(e) {
    const subnav = e.target.closest(".header-mega__subnav");

    if (!subnav || subnav.classList.contains("is-active")) {
      return;
    }

    this.openSubNav(
      subnav,
      subnav.parentNode?.querySelector(".js-link") as HTMLElement
    );
  }

  openSubNav(group, link) {
    const openMenuHeight = group.children[0].offsetHeight;
    const viewportHeight =
      document.documentElement.clientHeight - this.el.clientHeight;

    group.style.height = `${Math.min(openMenuHeight, viewportHeight)}px`;
    set([group, link, this.el], "is-active");
    set([document.body], "menu-open");
  }

  closeSubNavOnLeave(e) {
    if (!isOver(breakpoint)) {
      return;
    }

    const link = e.currentTarget;
    const isActive = contains(link, "is-active");

    if (!isActive) {
      return;
    }
    this.queuedAction = setTimeout(() => {
      this.closeSubNav();
    }, 300);
  }

  closeSubNav() {
    close(this.links, this.groups);
    unset(this.el, "is-active");
    unset(document.body, "menu-open");
  }

  cancelClose() {
    clearTimeout(this.queuedAction);
  }

  hideNavigation() {
    close(this.links, this.groups);
    unset(this.nav, "is-active");
    unset(document.body, "menu-open");
    this.nav.style.height = "0px";
  }

  resizeHandler() {
    /* close navigation on desktop */
    close(this.links, this.groups);
    this.fixHeaderPosition();
  }

  hideActiveMenu(e) {
    close(this.links, this.groups);
  }

  destroy() {
    window.removeEventListener("resize", this.resizeHandler);
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("click", this.hideActiveMenu);
  }
}

export default (el) => new Header(el);
